import { OfficerRoleEnum } from '@shared/types/officerEnum';
import { OfficerDialogMode, OfficerDialogState } from './officer-dialog-state.class';
import { DirectorOfficerDialogState } from './director-officer-dialog-state.class';
import { ShareholderOfficerDialogState } from './shareholder-officer-dialog-state.class';

export function createOfficerDialogState(
  officerRole: OfficerRoleEnum,
  mode: OfficerDialogMode,
): OfficerDialogState {
  if (officerRole === OfficerRoleEnum.DIRECTOR) {
    return new DirectorOfficerDialogState(officerRole, mode);
  }

  if (officerRole === OfficerRoleEnum.SHAREHOLDER) {
    return new ShareholderOfficerDialogState(officerRole, mode);
  }

  throw new Error('Wrong officer role!');
}
